export function Child (parentId = null, visibleInput = true, type = 'category') {
    this.id = new Date().getTime();
    this.name = "";
    this.quantity = 0.00;
    this.uom = "";
    this.parentId = parentId;
    this.children = [];
    this.type = type;
    this.visibleInput = visibleInput;
    this.isSave = false;
    if (type === 'position') {
        this.costs = {
            workCosts: [],
            workCostsDeleted: [],
            materialCosts: [],
            materialCostsDeleted: [],
            driveCosts: [],
            driveCostsDeleted: [],
        }
    }   
}